import axios from "axios";
const kkoApiKey = process.env.VUE_APP_KKO_API_KEY;
export default {
  getOauthForm() {
    return axios({
      method: "get",
      url: "https://kauth.kakao.com/oauth/authorize",
      params: {
        client_id: kkoApiKey,
        redirect_uri: "http://localhost:8080/login",
        state: "KKO",
        response_type: "code",
        auth_type: "reauthenticate"
      },
      validateStatus: () => true,
      timeout: 13000
    })
      .then(res => {
        console.log(res);
      })
      .catch(err => {
        console.error(err);
        return {
          status: 500,
          message: "서버통신 오류",
          detail: {
            code: -1,
            message: "서버통신 오류"
          }
        };
      });
  },
  getListByAddr(keyword) {
    return axios({
      method: "get",
      headers: {
        Authorization: `KakaoAK ${kkoApiKey}`
      },
      url: "https://dapi.kakao.com/v2/local/search/address.json",
      params: {
        query: keyword
      },
      validateStatus: () => true,
      timeout: 13000
    })
      .then(res => {
        console.log(res);
        return {
          status: res.status,
          data: res.data
        };
      })
      .catch(err => {
        console.error(err);
        return {
          status: 500,
          message: "서버통신 오류",
          detail: {
            code: -1,
            message: "서버통신 오류"
          }
        };
      });
  },

  getListByKeyWord(keyword, categoryGrpCode) {
    return axios({
      method: "get",
      headers: {
        Authorization: `KakaoAK ${kkoApiKey}`
      },
      url: "https://dapi.kakao.com/v2/local/search/keyword.json",
      params: {
        query: keyword,
        category_group_code: categoryGrpCode
      },
      validateStatus: () => true,
      timeout: 13000
    })
      .then(res => {
        console.log(res);
        return {
          status: res.status,
          data: res.data
        };
      })
      .catch(err => {
        console.error(err);
        return {
          status: 500,
          message: "서버통신 오류",
          detail: {
            code: -1,
            message: "서버통신 오류"
          }
        };
      });
  }
};
